<div class="tw-w-full tw-flex tw-flex-col">

   
   @if (!isInsidePopup()) {
      <button (click)="onGoBack()" class="tw-flex tw-items-center tw-bg-transparent tw-border-0 tw-gap-2 tw-text-sm xl:tw-text-base tw-mb-6 tw-text-[#4F5A70] tw-no-underline tw-font-medium">
         <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m2.869 6.75 4.2 4.2L6 12 0 6l6-6 1.069 1.05-4.2 4.2H12v1.5z" fill="#4f5a70"/>
         </svg>
         Back
      </button>
   }

   <h2 class="tw-mb-2 tw-font-medium tw-text-2xl lg:tw-text-3xl tw-tracking-tight tw-text-content-blue">
      Verify your {{ verifyType() === 'email' ? 'Email' : 'Phone Number' }}
   </h2>
   <p class="tw-text-sm tw-text-[#475569] tw-mb-8 lg:tw-mb-10">
      We've sent a 4-digit code to <strong class="tw-text-content-blue tw-font-medium">{{ identifierText() }}</strong>. Please enter it below to verify your {{ verifyType() === 'email' ? 'email' : 'mobile number' }}.
   </p>

   <form class="tw-w-full tw-flex tw-flex-col tw-gap-3">
      <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>

      <div class="tw-min-h-4">
         @if (errorMessage()) {
            <div class="tw-w-full tw-bg-red-50 tw-border tw-border-red-200 tw-text-red-600 tw-px-4 tw-py-2 tw-rounded-base tw-text-sm tw-text-center tw-my-2">
               {{ errorMessage() }}
            </div>
         }
      </div>

      <div class="tw-flex tw-items-center tw-justify-between tw-text-xs lg:tw-text-sm">
         <span class="tw-text-[#9DA1A5] tw-tracking-wide">Didn't receive the code?</span>
         @if (canResend()) {
            <button (click)="onResend()" [disabled]="isResending()" type="button" class="tw-text-brand-green tw-border-0 tw-p-0 tw-bg-transparent tw-font-medium tw-cursor-pointer hover:tw-underline disabled:tw-opacity-50 disabled:tw-cursor-not-allowed">
               @if (isResending()) {
                  Resending...
               } @else {
                  Resend Code
               }
            </button>
         } @else {
            <div class="tw-text-brand-green tw-flex tw-items-center tw-gap-1">
               <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.5 1.5V0H9v1.5zM6 9.75h1.5v-4.5H6zm.75 6a6.5 6.5 0 0 1-2.616-.534 6.9 6.9 0 0 1-2.147-1.453 6.9 6.9 0 0 1-1.453-2.147A6.5 6.5 0 0 1 0 9q0-1.388.534-2.616a6.9 6.9 0 0 1 1.454-2.147 6.9 6.9 0 0 1 2.146-1.453A6.5 6.5 0 0 1 6.75 2.25a6.7 6.7 0 0 1 2.231.375q1.07.375 2.007 1.088l1.05-1.05 1.05 1.05-1.05 1.05a7.3 7.3 0 0 1 1.087 2.006A6.7 6.7 0 0 1 13.5 9q0 1.388-.534 2.616a6.9 6.9 0 0 1-1.453 2.146 6.9 6.9 0 0 1-2.147 1.454 6.5 6.5 0 0 1-2.616.534m0-1.5q2.175 0 3.713-1.537Q12 11.175 12 9t-1.537-3.713Q8.925 3.75 6.75 3.75T3.038 5.287Q1.5 6.826 1.5 9t1.538 3.713Q4.575 14.25 6.75 14.25" fill="#1fb16e"/>
               </svg>
               <span class="tw-text-trim tw-tabular-nums">{{ formatTime(countdown()) }}</span>
            </div>
         }
      </div>

      <button (click)="onVerify()" [disabled]="isLoading() || (otpValue?.length ?? 0) < 4" type="button" class="tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-brand-green tw-text-white tw-border-none tw-rounded-base tw-h-12 hover:tw-bg-opacity-80 tw-transition-colors disabled:tw-opacity-50 tw-cursor-pointer disabled:tw-cursor-not-allowed">
         @if (isLoading()) {
            <svg class="tw-animate-spin tw-h-5 tw-w-5 tw-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
               <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
               <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="tw-ml-2">Verifying...</span>
         } @else {
            Verify & {{ verifyType() === 'email' ? 'Continue' : 'Complete' }}
         }
      </button>

      <button (click)="onEditIdentifier()" type="button" class="tw-border-0 tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-[#475569] tw-text-xs lg:tw-text-sm tw-cursor-pointer hover:tw-text-brand-green">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.782 16.31 3 21l4.69-.782a3.96 3.96 0 0 0 2.151-1.106L20.42 8.532a1.98 1.98 0 0 0 0-2.8L18.269 3.58a1.98 1.98 0 0 0-2.802 0L4.888 14.16a3.96 3.96 0 0 0-1.106 2.15M14 6l4 4"/>
         </svg>
         Update {{ verifyType() === 'email' ? 'Email Address' : 'Phone Number' }}
      </button>
   </form>

   
</div>
